@if (visible$ | async) {
    <fieldset [formGroup]="materialSerialNumberGroup">
        <ng-container *ngrxLet="materialSerialNumber$; let materialSerialNumber">
            @if (materialSerialNumber.choices) {
                <div class="row">
                    <p class="col-sm-10 col-12" [innerHTML]="materialSerialNumber.description"></p>
                    <span class="col-12 col-sm-2 text-end filter-text">{{ elementTypeLabel$ | async }}</span>
                </div>
                @if (materialSerialNumber.choices) {
                    <pace-forms-choices
                        [choices]="materialSerialNumber.choices"
                        [formControl]="radioControl"
                    ></pace-forms-choices>
                }
            }
            <div class="row mb-sm-3">
                @if (displayHistoryButton$ | async) {
                    <div class="col-auto ms-auto d-flex align-items-center order-last">
                        <pace-forms-history-button
                            [uniqueId]="materialSerialNumber.uniqueId"
                        ></pace-forms-history-button>
                    </div>
                }
            </div>
            <div class="row mb-sm-3">
                <div class="col-sm-6 col-12" *ngrxLet="groupedMaterialSuggestion$; let groupedMaterialSuggestion">
                    <pace-forms-input-text
                        [id]="materialSerialNumber.materialXmlId"
                        [formControl]="materialInputField"
                        [label]="materialSerialNumber.materialLabel"
                        [typeahead]="groupedMaterialSuggestion"
                        typeaheadOptionField="sernrDescription"
                        [typeaheadMinLength]="0"
                        [typeaheadOptionsLimit]="groupedMaterialSuggestion.length"
                        [typeaheadItemTemplate]="materialNumberTemplate"
                        [typeaheadScrollable]="true"
                        [typeaheadOptionsInScrollableView]="8"
                        (typeaheadOnSelect)="autofillEquipment($event.item)"
                    ></pace-forms-input-text>
                </div>
                <div class="col-sm-6 col-12" *ngrxLet="serialNumberSuggestion$; let serialNumberSuggestion">
                    <pace-forms-input-text
                        [id]="materialSerialNumber.serialXmlId"
                        [label]="materialSerialNumber.serialLabel"
                        [formControl]="serialInputField"
                        [typeahead]="serialNumberSuggestion"
                        typeaheadOptionField="sernrDescription"
                        [typeaheadMinLength]="0"
                        [typeaheadOptionsLimit]="serialNumberSuggestion.length"
                        [typeaheadItemTemplate]="serialNumberTemplate"
                        [typeaheadScrollable]="true"
                        [typeaheadOptionsInScrollableView]="8"
                        (typeaheadOnSelect)="autofillEquipment($event.item)"
                    ></pace-forms-input-text>
                </div>
            </div>
            @if (displayRemarksField$ | async) {
                <div class="row mb-sm-3">
                    <div class="col-12">
                        <pace-forms-input-text
                            [id]="materialSerialNumber.xmlId"
                            [label]="materialSerialNumber.remarksLabel"
                            [formControl]="remarksControl"
                        ></pace-forms-input-text>
                    </div>
                </div>
            }
            @if (displayDescription$ | async) {
                <div class="row mb-sm-3">
                    <div class="col-12">
                        <pace-forms-input-text
                            [id]="materialSerialNumber.descriptionXmlId"
                            [label]="materialSerialNumber.descriptionLabel"
                            [formControl]="descriptionInputField"
                        ></pace-forms-input-text>
                    </div>
                </div>
            }
            @if (displayNotApplicableCheckbox$ | async) {
                <div class="row mb-sm-3">
                    <div class="col not-applicable">
                        <div class="checkbox-container">
                            <input
                                type="checkbox"
                                class="form-control"
                                id="{{ materialSerialNumber.id }}-not-applicable"
                                [formControl]="checkboxControl"
                            />
                            <label for="{{ materialSerialNumber.id }}-not-applicable">
                                @if (checkboxControl.value) {
                                    <fa-icon [icon]="faCheck" size="2x"></fa-icon>
                                }
                            </label>
                        </div>
                        <label
                            translate="F4M_NOT_APPLICABLE_LABEL"
                            for="{{ materialSerialNumber.id }}-not-applicable"
                        ></label>
                    </div>
                </div>
            }
        </ng-container>
    </fieldset>
}

<ng-template #materialNumberTemplate let-model="item">
    <span>{{ model.matnr }}</span>
    @if (model.description) {
        <span> - {{ model.description }}</span>
    }
</ng-template>
<ng-template #serialNumberTemplate let-model="item">
    <span>{{ model.sernr }}</span>
    @if (model.description) {
        <span> - {{ model.description }}</span>
    }
</ng-template>
